import { LocationModel } from '@/services/api.service';
import { JobItemType } from '@/common/enumerations';

export interface IScheduleItem {
  id: string;
  status: string;
  title: string;
}

export class JobScheduleItem implements IScheduleItem {
  public id: string = '';
  public jobItemScheduleGid: string = '';
  public jobItemGid: string = '';
  public jobGid: string = '';
  public status: string = '';
  public savedStatus: string = ''; // Tracks the last saved/confirmed status for comparison
  public title: string = '';
  public jobName: string = '';
  public jobItemName: string = '';
  public network: string = '';
  public networkGid: string = '';
  public networkHexColor: string = '';
  public numberOfLots: number = 0;
  public serviceType: string = '';
  public jobItemType: JobItemType = JobItemType.Underground;
  public assignedToEmployee: string = '';
  public assignedToEmployeeGid: string = '';
  public scheduledTimeRange: string = '';
  public locationGid?: string | undefined;
  public location?: LocationModel;
  public notes: string = '';
  public orderIndex?: number | undefined;
  public scheduledDate?: Date | undefined;

  constructor(data?: IScheduleItem) {
    if (data) {
        for (const property in data) {
            if (data.hasOwnProperty(property)) {
                (this as any)[property] = (data as any)[property];
              }
        }
    }
  }


}

export enum DayColumnType {
  weekday,
  weekend,
  unscheduled
}
export class DayColumn {
  public id: string = ''; // Will be the iso date/'Unassigned'
  public class: string = 'weekday'; // bound to the class property of the column
  public name: string = '';
  public date: Date | null = null;
  public type: DayColumnType = DayColumnType.weekday;
  public isPublicHoliday: boolean = false;
}
